import React, { useCallback, useContext } from 'react';

import { MainContext, useTranslation } from '@ezbobdev/ui-framework';

export const useContactForm = (props) => {
  const { open, onClose } = props;
  const { actions, sdkActions } = useContext(MainContext);
  const { t } = useTranslation();

  const icon = actions.settings.getUserConfigProp(`widgetsConfig.contactForm.icon`);

  const sendContactFormData = useCallback(async () => {
    const userID = actions.case.getCaseValue('contactForm.id');
    const userFirstName = actions.case.getCaseValue('contactForm.fullName.firstName');
    const userLastName = actions.case.getCaseValue('contactForm.fullName.lastName');
    const userPhoneNumber = actions.case.getCaseValue('contactForm.phone');
    const contactFormDescription = actions.case.getCaseValue('contactForm.description');

    const isValid = actions.caseValidation.validateSpecificFields([
      'contactForm.fullName.firstName',
      'contactForm.fullName.lastName',
      'contactForm.id',
      'contactForm.phone',
      'contactForm.description',
    ]);

    if (isValid) {
      try {
        await sdkActions.crm.sendCRMForm({
          lastName: userLastName,
          firstName: userFirstName,
          description: contactFormDescription,
          phoneNumber: userPhoneNumber,
          id: userID,
        });
        actions.view.setAlerts([{ message: t(`contactForm.alert.success`), type: 'success' }]);
      } catch (e) {
        console.error(e);
      }

      onClose();
    }
  }, [actions.case]);

  return {
    sendContactFormData,
    open,
    onClose,
    icon,
  };
};
